import Column from '@components/Column';
import useAppCustom from '@hooks/useAppCustom';
import { useFlow } from '@router/stackflow';
import { Fragment } from 'react';

import PlusIcon from './PlusIcon';
import styles from './styles.module.scss';

function NewGiftFab() {
  const { push } = useFlow();
  const handleRegister = () => {
    push('NewGiftBottomSheet', {});
  };
  const { useCouponButton, couponButtonText } = useAppCustom().membership;
  if (useCouponButton) {
    return (
          <Column className={styles.container}
                  onClick={handleRegister}
                  align='center'
                  spacing={10}>
              <div className={styles.floating}>
                  <PlusIcon/>
              </div>
              <button className={styles.button}>
                  {couponButtonText}
              </button>
          </Column>
    );
  }
  return (<Fragment/>);
}

export default NewGiftFab;
